const events = {};

export const eventBus = {
    on(event, handler) {
        if (!events[event]) {
            events[event] = [];
        }
        events[event].push(handler);
    },
    off(event, handler) {
        if (events[event]) {
            events[event] = events[event].filter(h => h !== handler);
        }
    },
    emit(event, payload) {
        if (events[event]) {
            events[event].forEach(handler => handler(payload));
        }
    }
};
